import { APP_LOADED } from '../../actions/app-loaded';
import { SEND_TO_ONE_APP, applicationLoaded } from '../../actions/one-app';
import { getCurrentUser, isOneAppSearchParam } from '@wix/communities-blog-client-common';
import { getConfig } from '../../services/config';
import createEnvironment from '../../services/create-environment';
import createPermissionChecker from '../../services/create-permission-checker';
import createPermissionHelpers from '../../services/create-permission-helpers';

export const ORIGIN_ONE_APP = 'oneApp';

export const logOneAppMessage = (...message) => {
  // eslint-disable-next-line no-console
  getConfig().logOneAppMessages && console.log(getConfig().bundleName, '[ONE APP]', ...message);
};

const COMMON_ACTION_HANDLERS = {
  [APP_LOADED]: () => applicationLoaded(),
  [SEND_TO_ONE_APP]: ({ origin, action, publish }) => (dispatch, getState) => {
    const shouldSendMessage = isOneAppSearchParam(getState());
    if (shouldSendMessage) {
      const message = { origin, ...action.payload };
      publish(message);
      logOneAppMessage(`sent message to ${ORIGIN_ONE_APP}`, message);
    }
  },
};

const noopMiddleware = () => (next) => (action) => next(action);

const oneAppMiddleware = (config) => (store) => {
  const { origin, i18n, subscribe, publish, messageHandlers = {}, actionHandlers: customActionHandlers } = config;
  const actionHandlers = { ...COMMON_ACTION_HANDLERS, ...customActionHandlers };
  const environment = createEnvironment(store);
  const user = getCurrentUser(store.getState());
  const { can } = createPermissionHelpers(createPermissionChecker(store.getState(), user));
  const t = i18n.t.bind(i18n);

  subscribe((message) => {
    if (message.origin !== ORIGIN_ONE_APP) {
      return;
    }

    logOneAppMessage(`received message from ${ORIGIN_ONE_APP}`, message);
    const handler = messageHandlers[message.type];
    handler && store.dispatch(handler({ t, message, environment, can }));
  });

  return (next) => (action) => {
    const handler = actionHandlers[action.type];
    handler && store.dispatch(handler({ t, origin, action, publish }));

    if (action.type !== SEND_TO_ONE_APP) {
      return next(action);
    }
  };
};

export default function createOneAppMiddleware(config) {
  return (store) => (isOneAppSearchParam(store.getState()) ? oneAppMiddleware(config) : noopMiddleware)(store);
}
